import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { allQueryParams } from '@aston/foundation';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';



if (document.getElementsByTagName('app-root').length) {

	const qp = allQueryParams()
	const noprod = !environment.production;
	window['__aston_debug_auth'] = noprod || qp.aston_debug_auth;
	window['__aston_debug_ws'] = noprod || qp.aston_debug_ws;
	window['__aston_bootstrap_time'] = new Date().getMilliseconds();

	if (environment.production) {
		enableProdMode();
	}

	platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
		.catch(err => console.error(err));

}
